import ImageUploader from "../../ImageUploader";

import styles from "./ImageSlot.module.css";

interface Props {
    editing?: boolean;
    image: File | string | null;
    label?: string;
    width?: number;
    height?: number;
    onImageChange?: (image: File | null) => void;
}

export default function ImageSlot({
    editing,
    image,
    label,
    width,
    height,
    onImageChange,
}: Props) {
    if (editing)
        return (
            <ImageUploader
                label={label}
                image={image}
                width={width ?? 340}
                height={height ?? 570}
                onImageSelected={(img) => {
                    if (onImageChange) onImageChange(img);
                }}
            />
        );

    return (
        <img
            className={styles.imageSlot}
            src={
                image
                    ? typeof image === "string"
                        ? `${import.meta.env.VITE_SERVER_URL}${image}`
                        : URL.createObjectURL(image)
                    : undefined
            }
            style={{
                width: `${width ?? 340}px`,
                height: `${height ?? 570}px`,
            }}
        />
    );
}
